import { render, staticRenderFns } from "./analysisItem.vue?vue&type=template&id=36a51048&"
import script from "./analysisItem.vue?vue&type=script&lang=js&"
export * from "./analysisItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports